import { gsap } from '../global/gsap';

const initTeamFilter = (section) => {
    const buttons = section.querySelectorAll('.js-filter-button');
    const cards = [...document.querySelectorAll('.team-card')];

    const toggleCards = (btn) => {
        if (btn.classList.contains('is-active')) return;

        buttons.forEach((button) => {
            button.classList.remove('is-active');
        });

        btn.classList.add('is-active');

        const { target } = btn.dataset;

        // Animate all cards out
        gsap.to(cards, {
            opacity: 0,
            y: 20,
            duration: 0.25,
            stagger: 0.025,
            ease: 'power2.inOut',
            onComplete: () => {
                cards.forEach((card) => {
                    card.style.display = 'none';
                });

                // if target == all, show all cards, otherwise filter them based on the selected filter target
                const toShow = target === 'all' ? cards : cards.filter((card) => card.dataset.type.includes(target));

                toShow.forEach((card) => {
                    card.style.display = 'block';
                });

                // Map through the cards to show and grab the images. The 'filter' removes any false/null values
                const images = toShow.map((card) => card.querySelector('.js-card-media')).filter(Boolean);

                // Hide cards and images
                gsap.set(toShow, { opacity: 0, y: 20 });
                gsap.set(images, { opacity: 0 });

                // Animate cards and images in
                const tl = gsap.timeline();
                tl.to(toShow, {
                    opacity: 1,
                    y: 0,
                    duration: 0.25,
                    stagger: 0.025,
                    ease: 'power2.out',
                });
                tl.to(
                    images, {
                        opacity: 1,
                        duration: 0.25,
                        stagger: 0.025,
                        ease: 'power2.out',
                    }, '-=0.2'
                );
            },
        });
    };

    buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
            toggleCards(btn);
        });
    });
};

export default initTeamFilter;
